import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H15.2858L11.9951 21.7263L8.74274 19H3V3ZM15.9106 9.15003L14.85 8.08937L11 11.9394L9.34998 10.2894L8.28932 11.35L11 14.0607L15.9106 9.15003Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleCheck;
